<div fxLayout="column" *ngIf="loading === 0" class="m-t-20">

  <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="20px" >
    <div xLayout="column" fxLayoutAlign="center center" fxFlex="10" class="thumbnail-container">
      <img *ngIf="product.previewArtifactId" class="image" src="/assets/images/no-image-icon.svg" lazyLoad="{{SituViewUrl}}/home/getimage?artifactid={{product.previewArtifactId}}&filename=thumbnail.webp" alt="">
      <img *ngIf="!product.previewArtifactId" class="no-image" src="/assets/images/no-image-icon.svg" alt="">
      <mat-icon class="view-3d-button link" *ngIf="product.previewArtifactId" (click)="onView3dPreview(); $event.stopPropagation();" color="accent" matTooltip="3D Preview">view_in_ar</mat-icon>
      <mat-icon class="generate-preview-button link" *ngIf="isSituUser" (click)="onGeneratePreview(); $event.stopPropagation();" color="accent" matTooltip="Generate Preview">preview</mat-icon>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between stretch" fxFlex="90">
      <mat-form-field fxFlex="100">
        <mat-label>Name</mat-label>
        <input type="text" matInput placeholder="Product Name" [(ngModel)]="product.name" [disabled]="readOnly" #nameModel="ngModel" required >
        <mat-error *ngIf="nameModel.errors?.['required']">
          Name is <strong>required</strong>
        </mat-error>
      </mat-form-field>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between stretch">
        <mat-form-field fxFlex="80" fxFlex.lt-md="100">
          <mat-label>SKU</mat-label>
          <input type="text" matInput placeholder="sku-001" [(ngModel)]="product.sku" [disabled]="readOnly">
        </mat-form-field>
        <div fxFlex="20" fxFlex.lt-md="100" class="mat-form-field">
          <mat-slide-toggle [(ngModel)]="product.hideSku" [disabled]="readOnly">Hide SKU</mat-slide-toggle>
        </div>
      </div>
      <div *ngIf="isSituUser" fxLayout="row" fxLayoutGap="5px" class="m-b-10" style="font-size: 0.75rem;">
        <b>Key:</b>
        <i *ngIf="product.callerReferenceKey">{{ product.callerReferenceKey }}</i>
        <a *ngIf="!product.callerReferenceKey" style="cursor: pointer;" (click)="assignCallerReferenceKey()"><i>Assign Caller Reference Key</i></a>
      </div>
    </div>
  </div>

  <mat-form-field class="p-t-20">
    <mat-label>Description</mat-label>
    <textarea matInput [(ngModel)]="product.description" [disabled]="readOnly"
      cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8">
    </textarea>
  </mat-form-field>

  <div class="brand-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between stretch" fxLayoutGap="15px">
    <mat-form-field>
      <mat-label>Brand</mat-label>
      <input matInput [formControl]="brandNameControl" type="text" [matAutocomplete]="brandAuto" (blur)="onCheckBrandName()">
      <mat-autocomplete #brandAuto="matAutocomplete" (optionSelected)="onBrandSelected($event)"
        (opened)="onClearBrand()">
        <mat-option *ngFor="let brand of filteredBrands | async" [value]="brand.name">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span [innerHtml]="brand.name | encodeHtml | highlight: brandNameControl.value"></span>
          </div>
        </mat-option>
      </mat-autocomplete>
      <mat-error>Invalid Brand</mat-error>
    </mat-form-field>

    <ng-container *ngIf="product.brand">
    <div class="mat-form-field">
      <div class="small-label">Brand Logo</div>
      <img class="product-brand-logo" alt="Brand Logo" [src]="product.brand.brandLogoUrl || '/assets/images/no-image-icon.svg'">
    </div>
    <div class="mat-form-field">
      <div class="small-label">Quality Level</div>
      <span>{{ QualityLevel[product.brand?.qualityLevel] || "Unset" }}</span>
    </div>
    <button mat-icon-button *ngIf="!readOnly" [matTooltip]="'Clear Brand'" (click)="onClearBrand()" [style.align-self]="'center'"><mat-icon>cancel</mat-icon></button>
    <a mat-icon-button [routerLink]="'/products/brands'" [queryParams]="{filter: product.brand.name}" [style.align-self]="'center'"matTooltip="Edit Brand">
      <mat-icon>open_in_new</mat-icon></a>
  </ng-container>
  <button *ngIf="!product.brandId && !readOnly" mat-icon-button [style.align-self]="'center'" matTooltip="Create a new brand" (click)="onOpenAddBrands()">
    <mat-icon>add</mat-icon></button>
  </div>

  <div class="quality-row" fxLayout.lt-md="column">
    <div class="quality-selector mat-form-field" fxLayoutAlign="start center">
      <mat-label>Quality Level</mat-label>
      <div fxLayout="column">
        <mat-button-toggle-group [(ngModel)]="product.qualityLevel" [disabled]="readOnly">
          <ng-container *ngFor="let quality of QualityLevel | enumKeyValue">
            <mat-button-toggle [value]="quality.value">{{ quality.key }}</mat-button-toggle>
          </ng-container>
        </mat-button-toggle-group>
        <small [ngStyle]="{'opacity': (product?.brand?.qualityLevel && !product?.qualityLevel) ? '1' : '0'}">
          Quality level inherited from brand</small>
      </div>
    </div>
    <mat-slide-toggle class="mat-form-field" [(ngModel)]="product.calloutsEnabled" [disabled]="readOnly">Show
      Callouts</mat-slide-toggle>
    <mat-slide-toggle *ngIf="isSituUser" class="mat-form-field" [(ngModel)]="product.isBillable" [disabled]="readOnly"
      matTooltip="Off = no charge — excluded from representation billing">Billable</mat-slide-toggle>
  </div>

  <mat-form-field class="p-t-20">
    <mat-label>Product URL</mat-label>
    <input type="text" matInput [(ngModel)]="product.productUrl" [disabled]="readOnly">
  </mat-form-field>

  <mat-form-field>
    <mat-label>Notes</mat-label>
    <textarea matInput [(ngModel)]="product.notes" [disabled]="readOnly" placeholder="Add notes about the product here."
      cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8">
    </textarea>
  </mat-form-field>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between stretch" fxLayoutGap="15px" class="p-t-30">
    <mat-form-field>
      <mat-label>Product Classification</mat-label>
      <mat-select [(ngModel)]="selectedProductClassificationId" (selectionChange)="onClassificationChange()" [disabled]="readOnly || !productClassifications || productClassifications.length === 0">
        <mat-option *ngFor="let item of productClassifications" [value]="item.id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Product Type</mat-label>
      <mat-select [(ngModel)]="product.productTypeId" (selectionChange)="onTypeChange()" [disabled]="readOnly || !productTypes || productTypes.length === 0" required>
        <mat-option *ngFor="let item of filterTypesByClassification()" [value]="item.id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="product.productTypeId" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="center space-between">
    <product-specification-tree
    [productSpecifications]="productSpecifications"
    [productTypeIdFilter]="product.productTypeId"
    [selectedProductSpecificationIds]="product.productSpecificationIds"
    [expandAll]="true"
    [readOnly]="readOnly"
    (onProductSpecificationSelectionChanged)="onProductSpecificationSelectionChanged($event)"
    ></product-specification-tree>
  </div>

  <div *ngIf="!readOnly" fxLayout="row" fxLayoutAlign="space-between none">
    <div fxLayoutAlign="start center" fxLayoutGap="15px" class="p-t-10">
      <div *ngIf="isAddMode && !product.callerReferenceKey">
        <button mat-stroked-button (click)="bulkCreate()">
          Bulk Create
        </button>
      </div>

      <div *ngIf="canDisableProduct()">
        <mat-slide-toggle [(ngModel)]="product.disabled" style="height: 50px">Disable Product</mat-slide-toggle>
      </div>
    </div>

    <div fxLayoutAlign="start center" fxLayoutGap="15px" class="p-t-10">
      <button type="button" mat-flat-button color="accent" (click)="applyProduct()" [disabled]="saveIsValid()">
        <mat-icon>done</mat-icon> Apply
      </button>

      <button type="button" mat-flat-button color="primary" (click)="saveProduct()" [disabled]="saveIsValid()">
        <mat-icon>save</mat-icon> Save
      </button>

      <button *ngIf="isAddMode" type="button" mat-flat-button color="primary" (click)="saveProductAndCreateAnother()" [disabled]="saveIsValid()">
        <mat-icon>add_box</mat-icon> Save and Create Another
      </button>

      <button type="button" mat-stroked-button color="basic" (click)="navigateBack()">
        <mat-icon>clear</mat-icon> Cancel
      </button>
    </div>
  </div>
</div>
